import styled from '@emotion/styled';

import { breakpoints } from 'styles/basic';

const Wrapper = styled.div`
  display: block;
`;

const Section = styled.div`
  & + & {
    margin-top: 4rem;
  }
  p {
    white-space: break-spaces;
  }
`;

const Figure = styled.figure`
  display: block;
  overflow: hidden;
  margin: 0 0 2rem;
  border: .3rem solid ${(props) => props.theme.mainColors.secondary};
  border-radius: 1rem;
  color: ${(props) => props.theme.color.darkGray};
  text-align: right;

  @media (min-width: ${breakpoints.smallTablet}) {
    float: right;
    width: 40%;
    margin: 0 0 2rem 2rem;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    margin-bottom: 4rem;
    margin-left: 4rem;
  }

  @media (min-width: ${breakpoints.smallLaptop}) {
    margin-left: 6rem;
  }
`;

const Image = styled.img`
  display: block;
  width: 100%;
`;

export {
  Wrapper,
  Section,
  Figure,
  Image
};
